/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-self-compare */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-shadow */
// FILE: components/PatientIntake/ConfirmPayment/ConfirmPayment.tsx
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

import Container from '@brands/Components/Container/Container';
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import OralHealthCoachingModal from '@brands/Dashboard/Dashboard/DashboardModals/OralHealthCoachingModal';
import ScheduleLiveConsultation from '@brands/Dashboard/Dashboard/DashboardModals/ScheduleLiveConsultation';
import SubmitCCConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitCCConfirmationModal';
import SubmitCEConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitCEConfirmationModal';
import SubmitConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitConfirmationModal';
import SubmitSOConfirmationModal from '@brands/Dashboard/Dashboard/DashboardModals/SubmitSOConfirmationModal';
import UnavailableTimeSlotModal from '@brands/Dashboard/Dashboard/DashboardModals/UnavailableTimeSlotModal';
import { medicalConditionQuestionsForTags } from '@brands/Dashboard/MedicalHistory/MedicalCondition/utils/questions';
import LinkedCareCoordinationRedirect from '@brands/Dashboard/MultiStage/LinkedCareCoordinationRedirect';
import { convertDateFormat, uploadMediaToCase } from '@brands/Dashboard/MyProfile/Patient/utils/utilsFunctions';
import { VerificationType } from '@brands/Dashboard/PatientForms/PatientForm/PaymentInformation/InsuranceModal/InsuranceVerificationModal';
import { getUploadedFileName } from '@brands/Dashboard/PatientForms/PatientForm/utils/clinicalEnablementFlow';
import { useStepUrl, useWindowSize } from '@brands/hooks';
import { useAppDispatch, useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { CaseIntakeQuestions, CasePayload, createNewCase } from '@brands/services/cases/createNewCase';
import { getOneCase } from '@brands/services/cases/getCaseById';
import {
  submitCaseIntake,
  updateCaseInsurance,
  updateCaseInsuranceAndIntake,
  updateCaseIntakeQuestions,
} from '@brands/services/cases/multiStage';
import { rescheduleCase, RescheduleCasePayload } from '@brands/services/cases/rescheduleCase';
import { defaultICaseValues } from '@brands/services/cases/types/defaultICaseValues';
import { CaseType, ICase, Pricing } from '@brands/services/cases/types/ICase';
import { addClinicalData } from '@brands/services/clinical_data/addClinicalData';
import { listClinicalData } from '@brands/services/clinical_data/listClinicalData';
import {
  CreateDentalHistoryParams,
  CreateMedicalConditionsParams,
  CreateMedicalHistoryParams,
} from '@brands/services/clinical_data/types/types';
import { updateClinicalData } from '@brands/services/clinical_data/updateClinicalData';
import { completeMobileHandoff } from '@brands/services/communication/completeMobileHandover';
import { getPricings, Pricings } from '@brands/services/identity/getPricings';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { updatePaymentProfile } from '@brands/services/identity/updatePaymentProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectIsFromHandOff } from '@brands/store/selectors/isFromHandOff';
import { selectLinkedCase } from '@brands/store/selectors/linkedCase';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setIsFromHandoff } from '@brands/store/slices/isFromHandOffSlice';
import { clearLinkedCase } from '@brands/store/slices/linkedCaseSlice';
import { setOrganizationPrices } from '@brands/store/slices/organizationPricingSlice';
import { resetForm, resetIsFromSmileScanReport, resetSelectedPatient } from '@brands/store/slices/patientFormSlice';
import { normalizeAdditionalInfo } from '@brands/Utils/additionalInfo';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { getSecondary } from '@brands/Utils/getPrimaryColor';
import { lastAmount, needsPayment } from '@brands/Utils/needsPayment';
import WarningIcon from '@mui/icons-material/Warning';
import { Box, Button, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { AiOutlineLeft } from 'react-icons/ai';
import { useLocation, useNavigate } from 'react-router-dom';

import { getCoachingPricing } from '../../../../services/identity/getCoachingPricing';
import { priceFor } from '../../../Dashboard/Patient/utils/helpers';
import { CollapsibleSection } from './components/CollapsibleSection';
import styles from './styles.module.scss';

const ConfirmPayment = (): JSX.Element => {
  const { linkedCaseId } = useAppSelector(selectLinkedCase);
  const { values } = useAppSelector(selectPatientForm);
  const { state } = useLocation();
  const caseType =
    (values.find((item) => item.form_question_id === 20)?.value.caseType as string) || state?.caseType || '';
  return (
    <LinkedCareCoordinationRedirect caseId={caseType === CaseType.care_coordination ? linkedCaseId : null}>
      <ConfirmPaymentForm />
    </LinkedCareCoordinationRedirect>
  );
};

const ConfirmPaymentForm = (): JSX.Element => {
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector(selectAuth);
  const screenSize = useWindowSize();
  const [loading, setLoading] = useState<boolean>(false);
  const currentState: string = useAppSelector(selectCurrentPatientState);
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const isFromHandoffMobile = useAppSelector(selectIsFromHandOff);
  const { values, selectedPatient } = useAppSelector(selectPatientForm);
  const { currentOrganization } = useAppSelector(selectOrganization);
  const [displayUnavailableTimeSlotModal, setDisplayUnavailableTimeSlotModal] = useState(false);
  const [scheduleModal, setScheduleModal] = useState<{ openModal: boolean; currentCase: ICase }>({
    openModal: false,
    currentCase: defaultICaseValues,
  });
  const [oralHealthCoachingModal, setOralHealthCoachingModal] = useState<{ openModal: boolean; currentCase: ICase }>({
    openModal: false,
    currentCase: defaultICaseValues,
  });
  const [submitConfirmation, setSubmitConfirmation] = useState<boolean>(false);
  const [submitSOConfirmation, setSubmitSOConfirmation] = useState(false);
  const [submitCCConfirmation, setSubmitCCConfirmation] = useState(false);
  const [submitCEConfirmation, setSubmitCEConfirmation] = useState(false);
  const [rescheduleSuccessModal, setRescheduleSuccessModal] = useState<{
    openModal: boolean;
    updatedCase: ICase | null;
  }>({
    openModal: false,
    updatedCase: null,
  });
  const [isChecked, setIsChecked] = useState(false);
  const isSubmitDisabled = !isChecked;

  const { state } = useLocation();

  const verificationType = state?.verificationType as VerificationType | undefined;

  // Defensive: this screen is never the intended destination of a reschedule
  // (SelectProvider/SelectCareAdvisor patch the case directly and never
  // route here), but if RescheduleCase/caseId state survives to this point
  // anyway, patch the existing case instead of silently creating a new one.
  const rescheduleCaseId = state?.RescheduleCase && state?.caseId ? Number(state.caseId) : null;

  // A linked (multi-stage) case still in CaseStatus.upcoming, being
  // completed through this same wizard instead of a separate page — see
  // SelectPatient.tsx / completeLinkedCase.ts. Lives in Redux (linkedCaseSlice)
  // rather than router state, so it isn't lost on intermediate detours.
  // Patches the existing case (case_intake_questions and/or payment) instead
  // of POSTing a new one.
  const { linkedCaseId, linkedCasePatientId, linkedCaseNeedsPayment, previousClinicalData } =
    useAppSelector(selectLinkedCase);

  const blockedVerificationTypes: VerificationType[] = [
    'notCovered_No',
    'notCovered_Unsure',
    'invalid_No',
    'invalid_Unsure',
  ];

  const isInvalidVerification = verificationType !== undefined && blockedVerificationTypes.includes(verificationType);

  // Falls back to router state because a reschedule reaching this screen never
  // visited SelectCaseType, so form_question_id 20 is never set in the intake form.
  const caseType =
    (values.find((item) => item.form_question_id === 20)?.value.caseType as string) || state?.caseType || '';

  const currentOrganizationPrices = useAppSelector(selectOrganizationPrices);

  const p = priceFor(currentOrganizationPrices.currentOrganizationPrices, caseType as CaseType);

  const shouldHideSelfPay =
    p?.payment_options && p.payment_options.length === 1 && p.payment_options.includes('Insurance');

  const shouldBlockSelfPay = isInvalidVerification && shouldHideSelfPay;

  const getPlanField = <T,>(key: string): T | undefined => {
    const raw = values.find((i) => i.form_question_id === 19)?.value as unknown as unknown;
    const plan = (raw && typeof raw === 'object' && (raw as any).plan_payment) as unknown;
    if (plan && typeof plan === 'object' && key in (plan as Record<string, unknown>)) {
      return (plan as Record<string, unknown>)[key] as T;
    }
    return undefined;
  };

  const savedPaymentInformation = values.find((i) => i.form_question_id === 19)?.value as any;

  const payWithCredit: boolean =
    savedPaymentInformation?.payWithCredit === true ||
    getPlanField<boolean>('use_credit') === true ||
    getPlanField<string>('method') === 'CREDIT' ||
    getPlanField<string>('mode') === 'CREDIT';

  // Reflect the chosen payment method as a unique URL so analytics can track
  // drop-offs per method at the confirmation step. Plan credits skip the
  // payment-information form entirely, so this is their only unique URL.
  let confirmPaymentMethod: string | null = null;
  if (payWithCredit) {
    confirmPaymentMethod = 'plan-credits';
  } else if (savedPaymentInformation?.insuranceId) {
    confirmPaymentMethod = 'insurance';
  } else if (savedPaymentInformation) {
    confirmPaymentMethod = 'self-pay';
  }
  useStepUrl('confirm-payment', confirmPaymentMethod);

  const creditsRemainingAfter: number | undefined =
    typeof getPlanField<number>('remaining_after') === 'number'
      ? (getPlanField<number>('remaining_after') as number)
      : typeof savedPaymentInformation?.creditsRemainingAfter === 'number'
      ? savedPaymentInformation.creditsRemainingAfter
      : undefined;

  const creditsBefore = typeof creditsRemainingAfter === 'number' ? Math.max(creditsRemainingAfter + 1, 0) : undefined;

  const currentOrganizationPrice = currentOrganizationPrices.currentOrganizationPrices?.find((price: Pricings) =>
    price.case_types.includes(values.find((item) => item.form_question_id === 20)?.value.caseType as string),
  );

  const priceInCents = lastAmount(currentOrganizationPrice);

  const priceInDollars = priceInCents / 100;

  function isSelectedAppointmentTimeIsEnough(selectedTimeSlot: string): boolean {
    const selectedTime = new Date(selectedTimeSlot);
    const currentTime = new Date();
    const diffMinutes = (selectedTime.getTime() - currentTime.getTime()) / (1000 * 60);
    return diffMinutes >= 20;
  }

  const handleReset = (): void => {
    dispatch(resetForm());
    dispatch(resetSelectedPatient());
    dispatch(resetIsFromSmileScanReport());
    dispatch(setIsFromHandoff(false));
    dispatch(clearLinkedCase());
  };

  /** Admin/org/super-admin/collector creating a case for the selected patient (same patient_id / dependent_id rules). */
  const isCurrentUserAdmin = useMemo(
    () =>
      userInfo.role.name === UserRoleName.Admin ||
      userInfo.role.name === UserRoleName.SuperAdmin ||
      userInfo.role.name === UserRoleName.OrganizationAdmin ||
      userInfo.role.name === UserRoleName.Collector ||
      userInfo.role.name === UserRoleName.CareAdvisor,
    [userInfo.role.name],
  );

  // Care Coordination and Second Opinion are Self-payable regardless of the
  // org's pricing.payment_options config (see the matching carve-out in
  // PaymentInformation.tsx) — DO-4527. linkedCaseNeedsPayment is the ground
  // truth for a specific linked case (CaseIntakeState.upcoming_payment_required,
  // not org pricing config), covering every other case type the same way —
  // otherwise an org with no configured payment options for e.g.
  // video_call_scheduled silently strips payment_profile_id from the
  // reschedule PATCH even though the case genuinely still owes payment.
  const isPaymentRequired =
    (currentOrganizationPrices.currentOrganizationPrices?.find((pricing: Pricing) =>
      pricing.case_types.includes(values.find((item) => item.form_question_id === 20)?.value.caseType as string),
    )?.payment_options?.length ?? 0) > 0 ||
    caseType === CaseType.second_opinion ||
    caseType === CaseType.care_coordination ||
    linkedCaseNeedsPayment;

  // Backend only accepts this fixed vocabulary for substance_use — the form
  // itself stores its own display strings (see ClinicalDataStepSix.tsx),
  // which don't match, so they need translating rather than passed through.
  // There's no "Alcohol" checkbox in the current intake form at all; it's
  // listed here so it maps correctly if/when one is added.
  const SUBSTANCE_USE_LABELS: Record<string, string> = {
    'Tobacco Products': 'Tobacco',
    'Recreational Drugs': 'Drugs',
    'Prescription medication for non-medical reasons': 'Drugs',
    Alcohol: 'Alcohol',
  };

  const LAST_DENTIST_VISIT_LABELS: Record<string, string> = {
    within6Months: 'Within 6 months',
    'Within 6 months': 'Within 6 months',
    sixToTwelveMonths: '6-12 months ago',
    '6-12 months ago': '6-12 months ago',
    oneToTwoYears: '1-2 years ago',
    '1-2 years ago': '1-2 years ago',
    moreThanTwoYears: 'More than 2 years ago',
    'More than 2 years ago': 'More than 2 years ago',
    never: 'Never',
    Never: 'Never',
    dontKnow: "I don't know",
    "I don't know": "I don't know",
  };

  const asNonEmptyText = (value: unknown, fallback = 'None'): string => {
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (Array.isArray(value) && value.length) return value.join(', ');
    return fallback;
  };

  const asStringArray = (value: unknown): string[] => {
    if (Array.isArray(value)) {
      return value.filter((item): item is string => typeof item === 'string' && item.trim().length > 0);
    }
    return typeof value === 'string' && value.trim() ? [value.trim()] : [];
  };

  const buildClinicalEnablementIntakeAnswers = async (): Promise<Record<string, unknown>> => {
    const clinicalDataPatientId = Number(selectedPatient?.value) || Number(userInfo.id);
    const { medical_conditions, medical_history, dental_history } = await listClinicalData(clinicalDataPatientId);

    const selectedConditions = medicalConditionQuestionsForTags
      .filter(
        (question) => question.id !== 'conditions_not_listed' && question.id !== 'medical_condition_none_of_the_above',
      )
      .filter((question) => Boolean((medical_conditions as Record<string, unknown>)?.[question.id]))
      .map((question) => question.title);

    if (medical_conditions?.conditions_not_listed) {
      selectedConditions.push(medical_conditions.conditions_not_listed);
    }
    if (selectedConditions.length === 0) selectedConditions.push('None');

    const whoIsAppointmentFor =
      Number(selectedPatient?.value) === Number(userInfo.id) ? 'Myself' : selectedPatient?.label || 'Myself';

    const substanceUse = medical_history?.using_substances?.length
      ? Array.from(
          new Set(medical_history.using_substances.map((substance) => SUBSTANCE_USE_LABELS[substance] || substance)),
        ).filter((substance) => ['Tobacco', 'Drugs', 'Alcohol'].includes(substance))
      : ['None'];

    const lastDentistVisit = LAST_DENTIST_VISIT_LABELS[dental_history?.last_dental_visit || ''] || "I don't know";
    const reasonForVisit = asStringArray(dental_history?.visit_type);
    const additionalInfo = normalizeAdditionalInfo(
      values.find((item) => item.form_question_id === 16)?.value.additionalInfo,
    );
    const uploadedFileName = getUploadedFileName(values);

    const answers: Record<string, unknown> = {
      who_is_appointment_for: whoIsAppointmentFor,
      // Always-required per the backend's seeded intake question for this
      // case type — there's no "unless file uploaded" exception for it, and
      // no UI in the current wizard captures it, so it's hardcoded.
      appointment_location: 'Home',
      ...(uploadedFileName && { file_upload: uploadedFileName }),
      ...(additionalInfo && { note_to_dentist: additionalInfo }),
      medical_conditions: selectedConditions,
      under_physician_care: Boolean(medical_history?.under_care_of_physician),
      medications: medical_history?.taking_medication
        ? asNonEmptyText(medical_history?.medications, 'Yes — details not provided')
        : 'None',
      allergies: medical_history?.allergic_to_medications
        ? asNonEmptyText(medical_history?.medications_allergies, 'Yes — details not provided')
        : 'None',
      substance_use: substanceUse,
      quitting_products: Boolean(medical_history?.interested_in_stopping),
      height: asNonEmptyText(medical_history?.height, 'N/A'),
      weight: asNonEmptyText(medical_history?.weight, 'N/A'),
      last_dentist_visit: lastDentistVisit,
      dentist_seen: asNonEmptyText(dental_history?.who_did_you_see, "I don't know"),
      reason_for_visit: reasonForVisit.length ? reasonForVisit : ['None'],
    };

    if (medical_history?.under_care_of_physician) {
      answers.physician_conditions = asNonEmptyText(medical_history?.conditions_treated, 'Details not provided');
    }

    return answers;
  };

  const createCaseForThisRequirement = async (): Promise<ICase> => {
    const caseType =
      (values.find((item) => item.form_question_id === 20)?.value.caseType as string) || state?.caseType || '';
    let paymentRequired = isPaymentRequired;
    if (userInfo.role.name === UserRoleName.Patient && caseType === CaseType.oral_health_coaching) {
      const pricing = await getCoachingPricing((pricings) =>
        dispatch(setOrganizationPrices({ currentOrganizationPrices: pricings })),
      );
      paymentRequired = needsPayment(pricing);
      if (
        paymentRequired &&
        !savedPaymentInformation?.paymentId &&
        !savedPaymentInformation?.insuranceId &&
        !payWithCredit
      ) {
        roleNavigate('/payment-information', { state: { caseType } });
        throw new Error('Please provide payment information before booking Oral Health Coaching.');
      }
    }
    const intakeAnswers =
      caseType === CaseType.clinical_enablement ? await buildClinicalEnablementIntakeAnswers() : undefined;
    const payload: CasePayload = {
      type: caseType,
      status: 'new',
      patient_id: isCurrentUserAdmin
        ? currentPatient.guardian_id == null
          ? currentPatient?.id
          : currentPatient.guardian_id!
        : Number(userInfo.id),
      organization_id: currentOrganization?.id || 'dentistry-one',
      ...(caseType !== CaseType.oral_health_coaching && {
        provider_id:
          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'video_call_scheduled' ||
          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
            CaseType.phone_call_scheduled
            ? Number(values.find((item) => item.form_question_id === 14)?.value?.selectedProviderId)
            : undefined,
      }),
      ...(caseType === CaseType.oral_health_coaching && {
        care_advisor_id: Number(values.find((item) => item.form_question_id === 14)?.value?.selectedCareAdvisorId),
      }),
      payment_profile_id:
        paymentRequired || shouldBlockSelfPay
          ? savedPaymentInformation?.paymentId
            ? Number(savedPaymentInformation?.paymentId)
            : null
          : null,
      video_conference_date: (values.find((item) => item.form_question_id === 14)?.value?.selectedTimeSlot as string)
        ? convertDateFormat(values.find((item) => item.form_question_id === 14)?.value?.selectedTimeSlot as string)
        : null,
      patient_current_state: isCurrentUserAdmin
        ? currentState[currentPatient.id] || ''
        : currentState[userInfo.id] || '',
      ...(paymentRequired && {
        insurance_id: savedPaymentInformation?.insuranceId ? Number(savedPaymentInformation?.insuranceId) : null,
      }),
      ...(paymentRequired &&
        savedPaymentInformation?.usedInsuranceId && {
          used_insurance_id: Number(savedPaymentInformation?.usedInsuranceId),
        }),
      ...(paymentRequired &&
        savedPaymentInformation?.addSecondaryInsurance &&
        savedPaymentInformation?.secondaryInsuranceId !== '' && {
          second_insurance_id: savedPaymentInformation?.addSecondaryInsurance
            ? Number(savedPaymentInformation?.secondaryInsuranceId)
            : undefined,
        }),
      dependent_id: isCurrentUserAdmin
        ? currentPatient.guardian_id == null
          ? null
          : Number(currentPatient?.id)
        : Number(selectedPatient?.value) !== Number(userInfo.id)
        ? Number(selectedPatient?.value)
        : null,
      case_intake_questions: {
        is_dental_emergency: values.find((item) => item.form_question_id === 16)?.value.experiencingEmergency === true,
        in_pain: values.find((item) => item.form_question_id === 16)?.value.inPain === 'yes',
        pain_description: (values.find((item) => item.form_question_id === 16)?.value.describePain as string[]) || [],
        pain_time: (values.find((item) => item.form_question_id === 16)?.value.daysInPain as string) || '',
        pain_level: (values.find((item) => item.form_question_id === 16)?.value.painLevel as string) || '',
        reason_for_visit: (values.find((item) => item.form_question_id === 16)?.value.reasonForVisit as string[]) || [],
        additional_info: (values.find((item) => item.form_question_id === 16)?.value.additionalInfo as string) || '',
      },

      // 👇 NEW — let the backend decide whether to consume a credit
      ...({ pay_with_credits: payWithCredit } as any),

      // Non-breaking hint for backend about payment via plan credit (only set when selected)
      ...(payWithCredit && {
        plan_payment: {
          method: 'CREDIT',
          // Reserve/record intent only; deduction should happen upon case completion.
          credits_before: creditsBefore,
          credits_after: creditsRemainingAfter,
        },
      }),

      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...(((values.find((item) => item.form_question_id === 20)?.value.caseType as string) === CaseType.one_report ||
        (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
          CaseType.second_opinion) && {
        license_states: isCurrentUserAdmin ? [currentState[currentPatient.id] || ''] : [currentState[userInfo.id]],
      }),
      ...(intakeAnswers && { intake_answers: intakeAnswers }),
    };

    const caseRes = await createNewCase(payload, userInfo.role.name);
    return caseRes;
  };

  const rescheduleExistingCase = async (): Promise<ICase> => {
    const caseType =
      (values.find((item) => item.form_question_id === 20)?.value.caseType as string) || state?.caseType || '';
    const selectedTimeSlot = values.find((item) => item.form_question_id === 14)?.value;
    const payload: RescheduleCasePayload = {
      video_conference_date: convertDateFormat(selectedTimeSlot?.selectedTimeSlot as string),
      clinician_id:
        caseType === CaseType.oral_health_coaching
          ? Number(selectedTimeSlot?.selectedCareAdvisorId)
          : Number(selectedTimeSlot?.selectedProviderId),
      ...(caseType === CaseType.oral_health_coaching && { case_type: caseType }),
      payment_profile_id:
        isPaymentRequired || shouldBlockSelfPay
          ? savedPaymentInformation?.paymentId
            ? Number(savedPaymentInformation?.paymentId)
            : undefined
          : undefined,
    };

    return rescheduleCase(rescheduleCaseId as number, payload);
  };

  // Sync case types need a NEW appointment slot set on the existing case,
  // not just intake+payment — rescheduleCase's own payload comment confirms
  // it already doubles as "schedule a linked case for the first time" when
  // the case still needs payment, so it's reused here rather than a new
  // endpoint (unlike the legacy case_intake_questions types below).
  const SCHEDULED_LINKED_TYPES: string[] = [
    CaseType.video_call_scheduled,
    CaseType.phone_call_scheduled,
    CaseType.oral_health_coaching,
  ];

  // Writes the previous linked case's medical/dental history back onto the
  // patient's own clinical_data profile — the linked case flow never walks
  // the patient through /clinical-data again to re-collect it, so without
  // this a follow-up case would simply have none. Uses the same
  // add-if-missing/update-if-present pattern as the /clinical-data wizard
  // steps themselves (ClinicalDataStepOne.tsx etc.), reusing their existing
  // endpoints rather than a new case-level field.
  const applyPreviousClinicalData = async (patientId: number): Promise<void> => {
    if (!previousClinicalData) return;
    const { medicalHistory, medicalConditions, dentalHistory } = previousClinicalData;
    if (!medicalHistory && !medicalConditions && !dentalHistory) return;

    const existing = await listClinicalData(patientId).catch(() => null);
    const jobs: Promise<unknown>[] = [];

    if (medicalConditions) {
      const { id, user_id, ...rest } = medicalConditions;
      const payload: CreateMedicalConditionsParams = { ...rest, user_id: patientId };
      const existingId = existing?.medical_conditions?.id;
      jobs.push(
        existingId
          ? updateClinicalData('medical_conditions', existingId.toString(), payload)
          : addClinicalData('medical_conditions', payload),
      );
    }

    if (medicalHistory) {
      const { id, ...rest } = medicalHistory;
      const payload: CreateMedicalHistoryParams = { ...rest, user_id: patientId };
      const existingId = existing?.medical_history?.id;
      jobs.push(
        existingId
          ? updateClinicalData('medical_history', existingId.toString(), payload)
          : addClinicalData('medical_history', payload),
      );
    }

    if (dentalHistory) {
      const { id, user_id, ...rest } = dentalHistory;
      const payload: CreateDentalHistoryParams = { ...rest, user_id: patientId };
      const existingId = existing?.dental_history?.id;
      jobs.push(
        existingId
          ? updateClinicalData('dental_history', existingId.toString(), payload)
          : addClinicalData('dental_history', payload),
      );
    }

    await Promise.all(jobs);
  };

  // Shared by both branches below — scheduled case types collect the same
  // form_question_id 16 pain/reason-for-visit answers as legacy types (the
  // wizard's DescribePainLevel step doesn't branch by case type), so both
  // need to submit them, just via different endpoints (see below).
  const buildLinkedCaseIntakeQuestions = (): CaseIntakeQuestions => {
    const painLevel = (values.find((item) => item.form_question_id === 16)?.value.painLevel as string) || '';
    return {
      is_dental_emergency: values.find((item) => item.form_question_id === 16)?.value.experiencingEmergency === true,
      // There's no separate "in pain" question in the wizard (DescribePainLevel.tsx
      // never writes an `inPain` key) — painLevel itself is the source of truth,
      // with 'noPain' being the one option that means the patient isn't in pain.
      in_pain: painLevel !== '' && painLevel !== 'noPain',
      pain_description: (values.find((item) => item.form_question_id === 16)?.value.describePain as string[]) || [],
      pain_time: (values.find((item) => item.form_question_id === 16)?.value.daysInPain as string) || '',
      pain_level: painLevel,
      reason_for_visit: (values.find((item) => item.form_question_id === 16)?.value.reasonForVisit as string[]) || [],
      additional_info: (values.find((item) => item.form_question_id === 16)?.value.additionalInfo as string) || '',
    };
  };

  // Completes a linked case still sitting in CaseStatus.upcoming: attaches
  // payment or insurance first (whichever the patient chose; if this case
  // carries a cost and isn't a scheduled type — those attach payment_profile_id
  // directly on the reschedule call instead), then submits whatever
  // intake/scheduling this case type still needed. Payment/insurance-first so
  // a declined card or invalid insurance selection stops here before any
  // intake data is written — resolve_upcoming_case (backend) only flips the
  // case once BOTH are satisfied regardless of call order, so this is purely
  // about failing fast on the more failure-prone step. Care coordination
  // collects no case_intake_questions on this path (createCaseForThisRequirement
  // hardcodes them empty for CC too), so there's nothing to submit for it
  // except payment/insurance. clinical_enablement uses the data-driven intake
  // (submitCaseIntake). Every other case type still on the legacy
  // case_intake_questions shape goes through updateCaseIntakeQuestions —
  // same fields createCaseForThisRequirement builds for a brand-new case,
  // just PATCHed onto the existing linked case instead.
  const submitLinkedCase = async (): Promise<ICase> => {
    const caseType = (values.find((item) => item.form_question_id === 20)?.value.caseType as string) || '';

    // PaymentInformation.tsx's canShowCredits is gated off for a linked case
    // (there's no PATCH-based way to attach a credits payment to an
    // existing case, only the brand-new-case POST /cases payload supports
    // it), so this should be unreachable — but if stale Redux state from
    // before that gate somehow gets here, fail loudly instead of silently
    // submitting with no payment attached and leaving the case stuck in
    // CaseStatus.upcoming.
    if (payWithCredit) {
      throw new Error(
        'Plan credits cannot be used to complete an existing linked case — please select a card or insurance.',
      );
    }

    // Carried over regardless of case type — see applyPreviousClinicalData.
    if (linkedCasePatientId) {
      await applyPreviousClinicalData(linkedCasePatientId);
    }

    // Care coordination collects no case_intake_questions on this path
    // (createCaseForThisRequirement hardcodes them empty for CC too) —
    // nothing to submit for it. clinical_enablement uses the data-driven
    // intake (submitCaseIntake) instead of the legacy shape. Every other
    // case type here (including all of SCHEDULED_LINKED_TYPES) still goes
    // through updateCaseIntakeQuestions.
    const submitIntakeForCaseType = async (): Promise<void> => {
      if (caseType === CaseType.clinical_enablement) {
        const answers = await buildClinicalEnablementIntakeAnswers();
        await submitCaseIntake(linkedCaseId as number, answers);
      } else if (caseType !== CaseType.care_coordination) {
        await updateCaseIntakeQuestions(linkedCaseId as number, buildLinkedCaseIntakeQuestions());
      }
    };

    if (SCHEDULED_LINKED_TYPES.includes(caseType)) {
      // Attach payment explicitly, before scheduling — don't rely solely on
      // rescheduleCase's own optional payment_profile_id field accepting it
      // in the same call. Kept in the reschedule payload too, redundantly,
      // in case the backend still expects it there as well. Insurance has
      // no equivalent field on reschedule, so it's only ever submitted here,
      // merged with intake into one PATCH /patients/cases/{id} call since
      // both already hit that same route (a card payment lives at a
      // different route, so it stays its own call either way).
      if (isPaymentRequired && savedPaymentInformation?.paymentId) {
        await updatePaymentProfile(linkedCaseId as number, {
          payment_profile_id: Number(savedPaymentInformation.paymentId),
        });
        await submitIntakeForCaseType();
      } else if (isPaymentRequired && savedPaymentInformation?.insuranceId) {
        await updateCaseInsuranceAndIntake(
          linkedCaseId as number,
          {
            insurance_id: Number(savedPaymentInformation.insuranceId),
            second_insurance_id:
              savedPaymentInformation?.addSecondaryInsurance && savedPaymentInformation?.secondaryInsuranceId !== ''
                ? Number(savedPaymentInformation.secondaryInsuranceId)
                : null,
          },
          buildLinkedCaseIntakeQuestions(),
        );
      } else {
        await submitIntakeForCaseType();
      }

      const selectedTimeSlot = values.find((item) => item.form_question_id === 14)?.value;
      await rescheduleCase(linkedCaseId as number, {
        video_conference_date: convertDateFormat(selectedTimeSlot?.selectedTimeSlot as string),
        clinician_id:
          caseType === CaseType.oral_health_coaching
            ? Number(selectedTimeSlot?.selectedCareAdvisorId)
            : Number(selectedTimeSlot?.selectedProviderId),
        ...(caseType === CaseType.oral_health_coaching && { case_type: caseType }),
        ...(isPaymentRequired &&
          savedPaymentInformation?.paymentId && {
            payment_profile_id: Number(savedPaymentInformation.paymentId),
          }),
      });
      return getOneCase(linkedCaseId as number);
    }

    if (isPaymentRequired && savedPaymentInformation?.paymentId) {
      await updatePaymentProfile(linkedCaseId as number, {
        payment_profile_id: Number(savedPaymentInformation.paymentId),
      });
      await submitIntakeForCaseType();
    } else if (isPaymentRequired && savedPaymentInformation?.insuranceId) {
      const insurancePayload = {
        insurance_id: Number(savedPaymentInformation.insuranceId),
        second_insurance_id:
          savedPaymentInformation?.addSecondaryInsurance && savedPaymentInformation?.secondaryInsuranceId !== ''
            ? Number(savedPaymentInformation.secondaryInsuranceId)
            : null,
      };
      // clinical_enablement/care_coordination each submit intake (or
      // nothing) their own way, so insurance stays a standalone call for
      // them; every other type merges with intake into one PATCH call.
      if (caseType !== CaseType.clinical_enablement && caseType !== CaseType.care_coordination) {
        await updateCaseInsuranceAndIntake(linkedCaseId as number, insurancePayload, buildLinkedCaseIntakeQuestions());
      } else {
        await updateCaseInsurance(linkedCaseId as number, insurancePayload);
        await submitIntakeForCaseType();
      }
    } else {
      await submitIntakeForCaseType();
    }

    return getOneCase(linkedCaseId as number);
  };

  const completeMobileHandoffFn = async (): Promise<void> => {
    try {
      await completeMobileHandoff();
      dispatch(setIsFromHandoff(false));
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  const dispatchSuccessEvent = (serviceType: string): void => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'thank-you-screen-shown',
      service: serviceType,
      userId: userInfo.id,
    });
  };

  const onSubmit = async (): Promise<any> => {
    const slot = values.find((item) => item.form_question_id === 14)?.value?.selectedTimeSlot as string;
    const caseType = (values.find((item) => item.form_question_id === 20)?.value.caseType as string) || state?.caseType;

    if ((caseType === CaseType.video_call_scheduled || caseType === CaseType.phone_call_scheduled) && slot) {
      if (!isSelectedAppointmentTimeIsEnough(slot)) {
        setDisplayUnavailableTimeSlotModal(true);
        return;
      }
    }

    if (!caseType) {
      // The intake form has no case type left to submit — without this the
      // button simply does nothing and the patient has no way to tell why.
      displayErrorDetails('Your appointment details are no longer available. Please start again from your dashboard.');
      return;
    }

    setLoading(true);
    try {
      if (rescheduleCaseId) {
        const updatedCase = await rescheduleExistingCase();
        setRescheduleSuccessModal({ openModal: true, updatedCase });
        return;
      }

      if (linkedCaseId) {
        const updatedCase = await submitLinkedCase();

        const linkedCaseImagesValue = values.find((item) => item.form_question_id === 17)?.value.images;
        if (Array.isArray(linkedCaseImagesValue)) {
          // Await so the media is attached to the case's one_report before we
          // navigate to the confirmation modal — same ordering requirement as
          // the brand-new-case path below.
          await uploadMediaToCase(updatedCase, linkedCaseImagesValue, userInfo.role.name);
        }

        // Reset the wizard (including linkedCase) right here, on success —
        // every branch below either shows a confirmation modal and returns
        // (skipping the handleReset() at the bottom entirely) or falls
        // through to it, so without this, completing a linked case whose
        // type has a dedicated modal left linkedCaseId/linkedCasePatientId/
        // linkedCaseNeedsPayment/previousClinicalData sitting in Redux
        // indefinitely — not persist-blacklisted, so it even survived a
        // reload and could leak into an unrelated later flow.
        handleReset();

        if (updatedCase.type === 'video_call_scheduled' || updatedCase.type === CaseType.phone_call_scheduled) {
          dispatchSuccessEvent('talk-live-scheduled');
          setScheduleModal({ openModal: true, currentCase: updatedCase });
          return;
        }
        if (updatedCase.type === CaseType.oral_health_coaching) {
          dispatchSuccessEvent('oral_health_coaching');
          setOralHealthCoachingModal({ openModal: true, currentCase: updatedCase });
          return;
        }
        if (updatedCase.type === CaseType.care_coordination) {
          dispatchSuccessEvent('care_coordination');
          setSubmitCCConfirmation(true);
          return;
        }
        if (updatedCase.type === CaseType.clinical_enablement) {
          dispatchSuccessEvent('clinical-enablement');
          setSubmitCEConfirmation(true);
          return;
        }
        if (updatedCase.type === 'one_report') {
          dispatchSuccessEvent('send-photos');
          setSubmitConfirmation(true);
          return;
        }
        if (updatedCase.type === 'second_opinion') {
          dispatchSuccessEvent('second-opinion');
          setSubmitSOConfirmation(true);
          return;
        }
        // handleReset() already ran above for this branch too.
        roleNavigate(`/consultation-page/${updatedCase.id}`);
        return;
      }

      const res = await createCaseForThisRequirement();

      if (isFromHandoffMobile) {
        await completeMobileHandoffFn();
      }

      const imagesValue = values.find((item) => item.form_question_id === 17)?.value.images;
      if (Array.isArray(imagesValue)) {
        // Await so the media is attached to the case's one_report before we
        // navigate to the confirmation modal / consultation page. Without
        // this, the patient self-serve intake can race the navigation and
        // the consultation page renders before any image is attached.
        await uploadMediaToCase(res, imagesValue, userInfo.role.name);
      }

      // Route to the appropriate confirmation modal
      if (res && (res.type === 'video_call_scheduled' || res.type === CaseType.phone_call_scheduled)) {
        dispatchSuccessEvent('talk-live-scheduled');
        setScheduleModal({ openModal: true, currentCase: res });
        return;
      }
      if (res && res.type === CaseType.care_coordination) {
        dispatchSuccessEvent('care_coordination');
        setSubmitCCConfirmation(true);
        return;
      }
      if (res && res.type === CaseType.oral_health_coaching) {
        dispatchSuccessEvent('oral_health_coaching');
        setOralHealthCoachingModal({ openModal: true, currentCase: res });
        return;
      }
      if (res && res.type === 'one_report') {
        dispatchSuccessEvent('send-photos');
        setSubmitConfirmation(true);
        return;
      }
      if (res && res.type === 'second_opinion') {
        dispatchSuccessEvent('second-opinion');
        setSubmitSOConfirmation(true);
        return;
      }
      if (res && res.type === CaseType.clinical_enablement) {
        dispatchSuccessEvent('clinical-enablement');
        setSubmitCEConfirmation(true);
        return;
      }

      if (res) {
        // No dedicated confirmation modal for this case type. Reset the intake
        // state as before, but send the patient somewhere real — leaving them
        // on a wiped form looks like the submission failed and invites a
        // duplicate case.
        handleReset();
        roleNavigate(`/consultation-page/${res.id}`);
      }
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading fullScreen />;

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{ justifyContent: screenSize.width >= 564 ? 'center' : 'start' }}
      childrenStyle={{ zIndex: '2', paddingTop: screenSize.width > 768 ? '40px' : '16px' }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={styles.patientFormContainer}>
        <PatientIntakeNavigation progress={100} />
        <form className={styles.formContainer}>
          <div className={styles.wrapper}>
            <div className={styles.formContent}>
              <span className={`fs-unmask ${styles.paymentInfoTitle}`} data-testid="confirm-payment-title">
                Confirm payment and schedule
              </span>

              <Box className={`fs-unmask ${styles.confirmPaymentContainer}`} data-testid="confirm-payment-cost-div">
                {!payWithCredit ? (
                  <>
                    <Typography
                      className={`fs-unmask ${styles.confirmPaymentContainerEstimated}`}
                      color="text.secondary"
                    >
                      {savedPaymentInformation &&
                      savedPaymentInformation.insuranceId !== '' &&
                      savedPaymentInformation.medicaidAnswer !== '' &&
                      savedPaymentInformation.medicaidAnswer !== 'yes'
                        ? 'Estimated cost of this visit'
                        : 'Cost of this Visit'}
                    </Typography>

                    <Typography
                      className={`fs-unmask ${styles.confirmPaymentContainerEstimatedPrice}`}
                      variant="h3"
                      fontWeight="bold"
                      data-testid="confirm-payment-cost"
                    >
                      {savedPaymentInformation && savedPaymentInformation.paymentId !== ''
                        ? `$${priceInDollars.toFixed(2)}`
                        : '$0.00'}
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography
                      className={`fs-unmask ${styles.confirmPaymentContainerEstimated}`}
                      color="text.secondary"
                      data-testid="confirm-payment-covered-label"
                    >
                      Cost of this Visit
                    </Typography>
                    <Typography
                      className={`fs-unmask ${styles.confirmPaymentContainerEstimatedPrice}`}
                      variant="h3"
                      fontWeight="bold"
                      data-testid="confirm-payment-covered-value"
                    >
                      Covered by your plan
                    </Typography>

                    {typeof creditsRemainingAfter === 'number' && (
                      <Typography
                        className={`fs-unmask ${styles.confirmPaymentContainerEstimatedMaxPrice}`}
                        sx={{ borderBottom: '1px solid #E0E0E0', py: 1, width: '100%', paddingBottom: '16px' }}
                        color="text.secondary"
                        mt={2}
                        data-testid="confirm-payment-credits-remaining"
                      >
                        You’ll have{' '}
                        <strong>{creditsRemainingAfter === Infinity ? 'unlimited' : creditsRemainingAfter}</strong>{' '}
                        {creditsRemainingAfter === 1 ? 'credit' : 'credits'} remaining after this service.
                      </Typography>
                    )}

                    <CollapsibleSection title="How plan credits work">
                      We'll reserve one credit for this visit. Your credit will be{' '}
                      <strong>deducted only after the visit is completed</strong>. If the case is canceled, your credit
                      will be returned to you automatically.
                      <br />
                      <br />
                      If you're on an unlimited plan, this visit won't use any credits.
                    </CollapsibleSection>
                  </>
                )}

                {!payWithCredit &&
                  savedPaymentInformation &&
                  savedPaymentInformation.insuranceId !== '' &&
                  savedPaymentInformation.medicaidAnswer !== '' &&
                  savedPaymentInformation.medicaidAnswer !== 'yes' && (
                    <>
                      <Typography
                        className={`fs-unmask ${styles.confirmPaymentContainerEstimatedMaxPrice}`}
                        sx={{ borderBottom: '1px solid #E0E0E0', py: 1, width: '100%', paddingBottom: '16px' }}
                        color="text.secondary"
                        mt={2}
                        data-testid="confirm-payment-max-cost"
                      >
                        Maximum out of pocket cost: <span>$100</span>
                      </Typography>

                      <CollapsibleSection
                        title="How does insurance billing work?"
                        data-testid="confirm-payment-how-billing-work"
                      >
                        You’ll be paying our estimated out-of-pocket cost upfront, which includes your copay and
                        deductible (if available). After your visit, your insurance will process the claim and determine
                        if there’s any remaining balance.
                        <br />
                        <br />
                        If an additional balance is due, we’ll send you a bill via email and/or SMS. You’ll have 30 days
                        to pay the balance online.
                      </CollapsibleSection>

                      <CollapsibleSection title="Why is this an estimate?" data-testid="confirm-payment-why-estimate">
                        <ol style={{ listStyle: 'decimal', paddingLeft: '20px', margin: 0 }}>
                          <li style={{ display: 'list-item', listStyleType: 'decimal' }}>
                            Insurance benefits can differ between plans.
                          </li>
                          <li style={{ display: 'list-item', listStyleType: 'decimal' }}>
                            Deductible amounts are often not available in real-time.
                          </li>
                          <li style={{ display: 'list-item', listStyleType: 'decimal' }}>
                            The final cost depends on what your provider covers during the visit, which may vary based
                            on your individual case.
                          </li>
                        </ol>
                        <br />
                        Need help? Our support team is available Monday through Friday from 9:00am to 5:00pm ET{' '}
                        <Typography
                          component="a"
                          href="tel:+18777127875"
                          sx={{ color: getSecondary(), textDecoration: 'none' }}
                        >
                          +1 (877) 712-7875
                        </Typography>
                      </CollapsibleSection>
                    </>
                  )}

                <div
                  className={`fs-unmask ${styles.confirmPaymentContainerWarningDiv}`}
                  data-testid="confirm-payment-missed-appointment-div"
                >
                  <Typography
                    className={`fs-unmask ${styles.confirmPaymentContainerWarning}`}
                    variant="body1"
                    color="error"
                    fontWeight="bold"
                    mb={1}
                    mt={2}
                    data-testid="confirm-payment-missed-appointment"
                  >
                    <WarningIcon /> Missed appointments
                  </Typography>
                  <Typography
                    className={`fs-unmask ${styles.confirmPaymentContainerWarningText}`}
                    variant="body1"
                    color="error"
                    mb={2}
                  >
                    If you miss your scheduled appointment time, we reserve the right to charge for the full amount. You
                    can cancel your appointment for free up to 1 hour before it starts.
                  </Typography>
                </div>
              </Box>

              <Box
                className={`fs-unmask ${styles.confirmPaymentContainerAcceptText}`}
                data-testid="confirm-payment-accept"
              >
                <input
                  className={`form-check-input fs-unmask ${styles.checkInput} mt-0 ${
                    isChecked ? styles.primaryColor : ''
                  }`}
                  type="checkbox"
                  id="consent"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  data-testid="confirm-payment-accept-input"
                />
                <label htmlFor="consent" data-testid="confirm-payment-accept-label" className="fs-unmask">
                  By clicking “confirm payment”, I agree to Dentistry.One’s{' '}
                  <a
                    target="_blank"
                    href={`${window.location.origin}/consent-policy`}
                    style={{ color: getSecondary() }}
                    rel="noreferrer"
                  >
                    consent policy
                  </a>{' '}
                  and{' '}
                  <a
                    target="_blank"
                    href={`${window.location.origin}/notice-of-privacy-practices`}
                    style={{ color: getSecondary() }}
                    rel="noreferrer"
                  >
                    notice of privacy practices
                  </a>
                  .
                </label>
              </Box>

              <div className={styles.btnContainer}>
                <div className={styles.paymentSectionButtonDiv}>
                  <Button
                    variant="text"
                    type="button"
                    className={`fs-unmask ${styles.backBtnSticky}`}
                    onClick={() => navigate(-1)}
                    data-testid="confirm-payment-back"
                  >
                    <AiOutlineLeft /> Back
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    className={`fs-unmask ${styles.nextBtnSticky}`}
                    disabled={isSubmitDisabled}
                    data-testid="payment-information-form-submit"
                    onClick={() => onSubmit()}
                  >
                    {payWithCredit ? 'Confirm & Schedule' : 'Confirm Payment'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>

        {scheduleModal.openModal && <ScheduleLiveConsultation newCase={scheduleModal.currentCase} />}
        {rescheduleSuccessModal.openModal && (
          <ScheduleLiveConsultation newCase={rescheduleSuccessModal.updatedCase as ICase} isRescheduled />
        )}
        {submitConfirmation && <SubmitConfirmationModal />}
        {submitSOConfirmation && <SubmitSOConfirmationModal />}
        {submitCEConfirmation && <SubmitCEConfirmationModal />}
        {oralHealthCoachingModal.openModal && <OralHealthCoachingModal newCase={oralHealthCoachingModal.currentCase} />}
        {displayUnavailableTimeSlotModal && (
          <UnavailableTimeSlotModal setDisplayUnavailableTimeSlotModal={setDisplayUnavailableTimeSlotModal} />
        )}
        {submitCCConfirmation && <SubmitCCConfirmationModal />}
      </div>
    </Container>
  );
};

export default ConfirmPayment;
